import {z} from 'zod';

export const optionalEmailSchema = z.string().max(100).or(z.literal('').transform(() => undefined)).optional();
